import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetPatientDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Patient/GetDetail?` + params, null);

export const GetPatientList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Patient/GetList?` + params, null);

export const CreatePatient = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Patient/Create`, data);

export const UpdatePatient = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Patient/Update`, data);

export const UpdatePatientOPDAppointment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Patient/UpdatePatientOPDAppointment`, data);

export const DeletePatient = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Patient/Delete`, data);

// export const GetPatientListForSelect = (params: any) =>
//   GET_ENC(`${BASE_URL}/api/Patient/GetListForSelect?` + params, null);

export const GetPatientNumber = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Patient/GetPatientNumber?` + params, null);

export const GetPatientVaccinationList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Patient/GetVaccinationList?` + params, null);

export const GetOPDListByPatient = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Patient/GetOPDListByPatientDetail?` + params, null);
